// Componet for Badges of ProductGroup
// Author : Huen Oh (heons921@gmail.com)
// @param {string}   cyPrefix Prefix for data-cy.
// @param {string[]} data     List of strings for the badges.

<template>
  <div>
    <BaseBadge
      v-for="(group,index) in data" :key="group.value"
      :cyPrefix="`${cyPrefix}-badge-product-group-${index}`"
      :data="getNameByIdFromList(group, selectableProductGroups)"
      variant="primary"
      @onDelete="onDelete(index)"
    />
  </div>  
</template>


<script>
/**
 * Event on click of delete bagde.
 * 
 * @event BadgeListCProductGroup#onDelete
 * @type {object}
 * @param {number} index Index.
 */

import BaseBadge from '@/components/Common/BaseBadge'
import { getNameByIdFromList } from "@/utils/general.js"
import { mapGetters } from 'vuex'

export default {
  components:{
    BaseBadge,
  },
  computed:{
    ...mapGetters("product_group",  ["selectableProductGroups"]),
 },
  props:{
    // {string} Prefix for data-cy.
    cyPrefix: {
      type: String,
      default: ""
    },
    // {string[]} List of strings for the badges.
    data:{
      type:Array,
      default: () => []
    },
  },
  methods:{
    // Get name of an item from a list
    getNameByIdFromList,
    
    onDelete(index){
      // Event - BadgeListProductGroup#onDelete
      this.$emit('onDelete',index)
    }
  }
}
</script>
